import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=5471bf65&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=ts&"
export * from "./HomeView.vue?vue&type=script&lang=ts&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=5471bf65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471bf65",
  null
  
)

export default component.exports